/**
 * DR 선임/해임 목록 "이름 ([[director_id_label]]: [[director_identification_no]])" 의 ID 종류 라벨.
 *   예전 템플릿은 "NRIC:" 고정이라 외국인 이사(FIN·여권)도 NRIC 로 찍혔다.
 *   ID 종류(컨택트 idTypeName/코드 텍스트)가 있으면 그걸, 없으면 번호 형식(S/T=NRIC, F/G/M=FIN)으로 판정.
 */
export function directorIdLabel(idType: unknown, idNo: unknown): string {
  const t = String(idType ?? '').trim().toUpperCase();
  if (t.includes('NRIC')) return 'NRIC';
  if (t.includes('FIN')) return 'FIN';
  if (t.includes('PASSPORT') || t === 'PP') return 'Passport No.';
  const n = String(idNo ?? '').trim().toUpperCase();
  if (/^[ST]\d{7}[A-Z]$/.test(n)) return 'NRIC';
  if (/^[FGM]\d{7}[A-Z]$/.test(n)) return 'FIN';
  return n ? 'Passport No.' : 'NRIC';
}
